import { useEffect, useState } from 'react';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { EpisodeAuthorsActions } from 'app/store/EpisodeAuthors/EpisodeAuthors.slice';
// Selectors
import { selectAuthor } from 'app/store/EpisodeAuthors/EpisodeAuthors.selectors';
// Mui
import { Box } from '@mui/material';
// Utils
import { Context } from './utils/useAuthorTypeGroupContext';
// Components
import AuthorSuggestedButtons from './AuthorSuggestedButtons';
import AuthorControl from './AuthorControl';
import TypeControl from './TypeControl';

type Props = {
  ControlProps?: {
    disabled: boolean;
  };
};

const AuthorTypeGroup = ({ ControlProps }:Props) => {
  // Store
  const dispatch = useAppDispatch();
  // State
  const author = useAppSelector(selectAuthor);

  const [ openAuthorAutocomplete, setOpenAuthorAutocomplete ] = useState(false);

  const handleOpenAuthorAutocomplete = () => setOpenAuthorAutocomplete(true);
  const handleCloseAuthorAutocomplete = () => setOpenAuthorAutocomplete(false);

  const [ types, setTypes ] = useState<string[]>([]);

  useEffect(() => {
    return () => {
      dispatch(EpisodeAuthorsActions.setAuthor(null));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( !author ) return;

    setTypes(author.episodeTypes || []);
  }, [author]);

  return (
    <Context.Provider value={{
      ControlProps,
      openAuthorAutocomplete,
      onOpenAuthorAutocomplete: handleOpenAuthorAutocomplete,
      onCloseAuthorAutocomplete: handleCloseAuthorAutocomplete,
      // Types
      types,
      setTypes
    }}>
      <AuthorSuggestedButtons />
      <Box sx={{ display: 'flex', gap: 4, mb: 4 }}>
        <Box sx={{ flex: 1 }}>
          <AuthorControl />
        </Box>
        <Box sx={{ flex: 1 }}>
          <TypeControl />
        </Box>
      </Box>
    </Context.Provider>
  )
}

export default AuthorTypeGroup;
